import { render, staticRenderFns } from "./TableListByChargeScore.vue?vue&type=template&id=c4392ff8&"
import script from "./TableListByChargeScore.vue?vue&type=script&lang=js&"
export * from "./TableListByChargeScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports